import { render, staticRenderFns } from "./EsgPartnerQuarterlyEmission.vue?vue&type=template&id=28d8a521"
import script from "./EsgPartnerQuarterlyEmission.vue?vue&type=script&lang=js"
export * from "./EsgPartnerQuarterlyEmission.vue?vue&type=script&lang=js"
import style0 from "./EsgPartnerQuarterlyEmission.vue?vue&type=style&index=0&id=28d8a521&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports